import React from 'react';

interface LandingPageProps {
  onGetStarted: () => void;
  brandLogoUrl: string;
  partnerLogoUrl: string;
}

export const LandingPage: React.FC<LandingPageProps> = ({ onGetStarted, brandLogoUrl, partnerLogoUrl }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white text-brand-grey p-6 text-center relative">
      <header className="absolute top-6 left-6 flex flex-col items-center gap-3">
  <a
    href="https://sidbahri.com/"
    className="text-sm font-semibold text-gray-600 hover:underline"
    aria-label="Back to sidbahri.com"
  >
    ← Back to sidbahri.com
  </a>

  <p className="text-xl font-medium text-gray-600 leading-tight">A</p>

  <img
    src={partnerLogoUrl}
    alt="Partner Logo"
    className="h-12 my-2 object-contain"
    onError={(e) => {
      const img = e.currentTarget;
      if (!img.dataset.fallbackApplied) {
        img.dataset.fallbackApplied = '1';
        img.src = '/favicon.png';
      }
    }}
  />

  <p className="text-xl font-medium text-gray-600 leading-tight">Product.</p>
</header>

      <main className="flex flex-col items-center">
        <img
          src={brandLogoUrl}
          alt="One Size Fits None™ Logo"
          className="mb-10 animate-float"
          style={{ maxWidth: '300px', height: 'auto' }}
          onError={(e) => {
            const img = e.currentTarget;
            if (!img.dataset.fallbackApplied) {
              img.dataset.fallbackApplied = '1';
              img.src = '/favicon.png';
            }
          }}
        />

        <h1 className="text-4xl md:text-5xl font-semibold tracking-tight mb-4 max-w-2xl">
         Beyond the <span className="text-brand-orange">Uniform</span>
        </h1>

        <p className="text-lg md:text-xl max-w-3xl text-gray-600 mb-12">
          AI tools for <span className="text-brand-orange font-bold">Human Advantage.</span>
        </p>

        <button
          onClick={onGetStarted}
          className="px-10 py-4 bg-brand-orange text-white text-xl font-bold rounded-full shadow-lg hover:bg-opacity-90 transform hover:scale-105 transition-all duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-brand-orange focus:ring-opacity-50"
          aria-label="Get started with the application"
          type="button"
        >
          Get Started
        </button>
      </main>
    </div>
  );
};
